import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const TOKEN_KEY = "access_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

let refreshing = null;

const PUBLIC_PATHS = ["/login", "/reset-password", "/portal/", "/owner/", "/handover/"];

function redirectToLogin() {
  const path = window.location.pathname;
  const onPublic = PUBLIC_PATHS.some((p) => path === p || path.startsWith(p));
  if (!onPublic) window.location.assign("/login");
}

// Attach the stored JWT as a Bearer header so auth works even when the
// httpOnly cookie is not persisted by the browser (resilient / API-first).
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const status = error.response?.status;
    const isAuthUrl = (cfg?.url || "").includes("/auth/");
    if (status === 401 && cfg && !cfg._retry && !isAuthUrl) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const res = await refreshing;
        if (res?.data?.access_token) setToken(res.data.access_token);
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        // Session expired and refresh failed: clear token, send the user to
        // login and halt the chain so the rejection never surfaces uncaught.
        clearToken();
        redirectToLogin();
        return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function mediaUrl(signedPath) {
  return signedPath ? `${BACKEND}${signedPath}` : "";
}

export default api;
